var _rect, _text, _rect2, _circle, _text2, _text3, _text4, _path, _rect3, _circle2, _text5, _text6, _text7, _path2, _rect4, _circle3, _text8, _text9, _text0, _rect5, _text1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusDifferenceOperationalValuePathwayMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 520,
    viewBox: "0 0 360 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Operational value pathway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 518,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 38,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    dy: 0
  }, "FROM WORK TO VALUE"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 64,
    width: 312,
    height: 106,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#C9DDF1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 98,
    r: 16,
    fill: "#087CFF",
    fillOpacity: 0.13,
    stroke: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 102,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 101,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: 850
  }, "UNDERSTAND")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 138,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "People, process, decisions and data.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 170v28",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 198,
    width: 312,
    height: 106,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#C9DDF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 232,
    r: 16,
    fill: "#FF2775",
    fillOpacity: 0.13,
    stroke: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 236,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 235,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: 850
  }, "BUILD")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 272,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "The right system for the environment.")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 304v28",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 332,
    width: 312,
    height: 106,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#C9DDF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 366,
    r: 16,
    fill: "#30D6A1",
    fillOpacity: 0.13,
    stroke: "#30D6A1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 370,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 369,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: 850
  }, "MEASURE")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 406,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Adoption, productivity and control.")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 460,
    width: 312,
    height: 38,
    rx: 12,
    fill: "#07152A"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 484,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "MEASURABLE OPERATIONAL IMPROVEMENT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusDifferenceOperationalValuePathwayMobile);
export default __webpack_public_path__ + "static/media/about-andus-difference-operational-value-pathway-mobile.5a6156300636cd48f30f515c581a207d.svg";
export { ForwardRef as ReactComponent };